import { tolgee } from "@/providers/TranslationProvider";

export const getBadgeStatusWorklistText = (actionRequired: string) => {
  switch (actionRequired) {
    case "DELIVERY_NEEDED":
      return tolgee.t("badgeStatus.worklist_DELIVERY_NEEDED");
    case "DESIGN_NEEDED":
      return tolgee.t("badgeStatus.worklist_DESIGN_NEEDED");
    case "MODIFICATION_REQUEST_APPROVAL_NEEDED":
      return tolgee.t(
        "badgeStatus.worklist_MODIFICATION_REQUEST_APPROVAL_NEEDED"
      );
    case "PRE_MEDIA_PROPOSITION_NEEDED":
      return tolgee.t("badgeStatus.worklist_PRE_MEDIA_PROPOSITION_NEEDED");
    case "PRE_MEDIA_PROPOSITION_VALIDATION_NEEDED":
      return tolgee.t(
        "badgeStatus.worklist_PRE_MEDIA_PROPOSITION_VALIDATION_NEEDED"
      );
    case "PRE_MEDIA_REQUEST_COMPLETION_NEEDED":
      return tolgee.t(
        "badgeStatus.worklist_PRE_MEDIA_REQUEST_COMPLETION_NEEDED"
      );
    case "PRE_MEDIA_REQUEST_SUBMISSION_NEEDED":
      return tolgee.t(
        "badgeStatus.worklist_PRE_MEDIA_REQUEST_SUBMISSION_NEEDED"
      );
    case "PRE_MEDIA_REQUEST_VALIDATION_NEEDED":
      return tolgee.t(
        "badgeStatus.worklist_PRE_MEDIA_REQUEST_VALIDATION_NEEDED"
      );
    case "PROOF_AVAILABLE":
      return tolgee.t("badgeStatus.worklist_PROOF_AVAILABLE");
    case "PROOF_NEEDED":
      return tolgee.t("badgeStatus.worklist_PROOF_NEEDED");
    case "PURCHASE_ORDER_NEEDED":
      return tolgee.t("badgeStatus.worklist_PURCHASE_ORDER_NEEDED");
    case "QUOTE_AVAILABLE":
      return tolgee.t("badgeStatus.worklist_QUOTE_AVAILABLE");
    case "QUOTE_NEEDED":
      return tolgee.t("badgeStatus.worklist_QUOTE_NEEDED");
    case "RETROPLANNING_SHARED":
      return tolgee.t("badgeStatus.worklist_RETROPLANNING_SHARED");
    case "RETROPLANNING_TO_FILL":
      return tolgee.t("badgeStatus.worklist_RETROPLANNING_TO_FILL");
    case "VALIDATION_NEEDED":
      return tolgee.t("badgeStatus.worklist_VALIDATION_NEEDED");
    default:
      return "";
  }
};
